<script setup>
import { useKeenSlider } from 'keen-slider/vue';
import { computed, ref } from 'vue';

// Components
import AddOnLabel from '@/Components/AddOnLabel.vue';
import ReviewCard from '@/Components/Review/ReviewCard.vue';
import { usePage } from '@inertiajs/vue3';

const current = ref(0);

const props = defineProps({
    title: String,
    reviews: Object,
    addOnLabel: Boolean,
});

const moduleActive = computed(() => usePage().props.template_options.modules.review_slider_active);

const [container, slider] = useKeenSlider(
    {
        initial: current.value,
        slides: props.reviews.length,
        slideChanged: (s) => {
            current.value = s.track.details.rel;
        },
        loop: true,
    },
    [
        (slider) => {
            let timeout;
            let mouseOver = false;
            function clearNextTimeout() {
                clearTimeout(timeout);
            }
            function nextTimeout() {
                clearTimeout(timeout);
                if (mouseOver) return;
                timeout = setTimeout(() => {
                    slider.next();
                }, 3000);
            }
            slider.on('created', () => {
                slider.container.addEventListener('mouseover', () => {
                    mouseOver = true;
                    clearNextTimeout();
                });
                slider.container.addEventListener('mouseout', () => {
                    mouseOver = false;
                    nextTimeout();
                });
                nextTimeout();
            });
            slider.on('dragStarted', clearNextTimeout);
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
        },
    ]
);

const dotHelper = computed(() => (slider.value ? [...Array(slider.value.track.details.slides.length).keys()] : []));
</script>

<template>
    <div class="relative text-white bg-black" v-if="moduleActive && reviews">
        <div class="container relative py-16 md:py-30" v-if="reviews && reviews.length">
            <AddOnLabel v-if="addOnLabel" />

            <div ref="container" class="keen-slider">
                <ReviewCard v-for="(review, i) in reviews" :key="review.id" :review="review" class="keen-slider__slide"
                    :class="`number-slide${i}`">
                    <div v-if="slider" class="flex gap-1 py-1 mt-10 md:py-2 md:gap-2">
                        <div v-for="(_slide, idx) in dotHelper" @click="slider.moveToIdx(idx)" :class="{
                            'bg-primary-inverted opacity-100': current === idx,
                            'bg-white/30 ': current !== idx,
                        }" :key="idx" class="w-2 h-2 rounded-full"></div>
                    </div>
                </ReviewCard>
            </div>
        </div>
    </div>
</template>

<style>
@import url('keen-slider/keen-slider.css');
</style>
